/** TanStack Query options shared by the pages that need every acquisition campaign — the
 *  campaign selects of «Расходы», «Пользователи» and «Когорты», and a campaign card opened off
 *  the current page of «Кампании» (review api-ui-8). One key, so they share one cache entry. */
import { api } from '@/lib/api'
import { ALL_CAMPAIGNS_KEY, loadAllCampaigns, type AcqCampaignsResponse } from '@/lib/acquisition'

export function allCampaignsQuery(enabled = true) {
  return {
    queryKey: [...ALL_CAMPAIGNS_KEY],
    queryFn: () => loadAllCampaigns((path) => api.get<AcqCampaignsResponse>(path), null),
    enabled,
  }
}
